import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { CardContent, CardHeader, Grid } from '@material-ui/core';
import { ServiceValues } from '../../../../../../values/ServiceValues';
import { ServiceAxios } from '../../../../../../services/ServiceEW';
import { useStyles } from './ModalidadeTrapAmericanoStyles';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelRodada from './ExpansionPanelRodada';
import { useTheme } from '@material-ui/styles';
import { Values } from '../../../../../../values/Values';
import { Bar, Doughnut } from 'react-chartjs-2';
import clsx from 'clsx';
import palette from 'theme/palette';
import ModalidadeDetalhes from '../ModalidadeDetalhes/ModalidadeDetalhes';



function ModalidadeTrapAmericano(props) {
  const baseUrl = ServiceValues.base_url_local;
  const timeout = ServiceValues.timeout;
  const api = ServiceAxios(baseUrl, timeout);
  const {
    filiado,
    setFiliado,
    setShowMessageSnack,
    setMessageSnack,
    setTypeSnack,
    setLoading,
    filiacaoStatus,
    gruposSanguineos,
    edicao,
    visitaFiliado,
    setVisitaFiliado,
    indexModalidade,
    armas,
    insumos,
    pacotes
  } = props;
  const classes = useStyles();
  const theme = useTheme();
  const [disparosTrapRodada, setDisparosTrapRodada] = useState(props.disparosTrapRodada);
  const [percentualAcertos, setPercentualAcertos] = useState(0);
  const [percentualErros, setPercentualErros] = useState(100);
  const [dataDoughnut, setDataDoughnut] = useState({
    datasets: [
      {
        data: [0, 25],
        backgroundColor: [
          theme.palette.primary.main,
          theme.palette.error.main,
          theme.palette.warning.main
        ],
        borderWidth: 4,
        borderColor: theme.palette.white,
        hoverBorderColor: theme.palette.white
      }
    ],
      labels: ['Acertos', 'Erros']
  });
  const [dataBar, setDataBar] = useState({
    labels: [],
    datasets: []
  });
  const options = {
    responsive: true,
    maintainAspectRatio: false,
  };
  const [refreshState, setRefreshState] = useState(new Date());
  const [expandedModalidade, setExpandedModalidade] = useState();
  const [expandedRodadas, setExpandedRodadas] = useState();
  const [expandedDetalhes, setExpandedDetalhes] = useState();
  const [expandedRendimento, setExpandedRendimento] = useState();

  useEffect(() => {
    async function recarregarVisita() {
      try {
        setLoading(true);
        const dados = await api.get(`visita-filiados/${visitaFiliado.idVisitaFiliado}`);
        setLoading(false);
        if (dados.data.isSuccess) {
          if (dados.data.result && dados.data.result.length > 0) {
            setVisitaFiliado(dados.data.result[0]);
            setLoading(false)
          } else {
            setLoading(false);
            setTypeSnack('error');
            setMessageSnack(Values.MessageValues.erro_catch);
            setShowMessageSnack(true);
          }
        } else {
          setLoading(false);
          setTypeSnack('error');
          setMessageSnack(Values.MessageValues.erro_catch);
          setShowMessageSnack(true);
        }
      } catch (e) {
        setLoading(false);
        setTypeSnack('error');
        setMessageSnack(Values.MessageValues.erro_catch);
        setShowMessageSnack(true);
      }
    }
    recarregarVisita();
  }, []);

  useEffect(() => {
    function reloadChartData() {
      if(visitaFiliado.visitaFiliadoMods){
        if(visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoTrap){
          let totalAcertos = 0
          let totalTiros = Values.quantidadeTirosRodadaTrap * visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoTrap.length;
          let totalRodadas = visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoTrap.length;
          let acertosRodada = [];
          let errosRodada = [];
          let labelsRodadas = [];
          visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoTrap.map(visitaFiliadoTrap => {
            totalAcertos += visitaFiliadoTrap.quantidadeAcertos;
            acertosRodada.push(visitaFiliadoTrap.quantidadeAcertos * 100 / Values.quantidadeTirosRodadaTrap);
            errosRodada.push((Values.quantidadeTirosRodadaTrap - visitaFiliadoTrap.quantidadeAcertos) * 100 / Values.quantidadeTirosRodadaTrap);
            labelsRodadas.push("Rodada " + visitaFiliadoTrap.numeroRodada);
          });
          setPercentualAcertos(totalAcertos * 100 / (totalRodadas * Values.quantidadeTirosRodadaTrap));
          setPercentualErros(((totalRodadas * Values.quantidadeTirosRodadaTrap) - totalAcertos) * 100/ (totalRodadas * Values.quantidadeTirosRodadaTrap));
          const dataDoughnutCopy = {
            datasets: [
              {
                data: [
                  totalAcertos,
                  totalTiros - totalAcertos
                ],
                backgroundColor: [
                  theme.palette.primary.main,
                  theme.palette.error.main,
                  theme.palette.warning.main
                ],
                borderWidth: 8,
                borderColor: theme.palette.white,
                hoverBorderColor: theme.palette.white
              }
            ],
            labels: ['Acertos', 'Erros']
          };
          setDataDoughnut(dataDoughnutCopy);
          const dataBarCopy = {
            labels: labelsRodadas,
            datasets: [
              {
                label: 'Percentual de acertos',
                backgroundColor: palette.primary.main,
                data: acertosRodada
              },
              {
                label: 'Percentual de erros',
                backgroundColor: theme.palette.error.dark,
                data: errosRodada
              },
            ]
          };
          setDataBar(dataBarCopy);
        }
      }
    }
    reloadChartData();
    setRefreshState(new Date());
  }, [visitaFiliado]);


  const handleChange = panel => (event, isExpanded) => {
    setExpandedModalidade(isExpanded ? panel : false);
  };

  const handleChangeExpandedRendimento = panel => (event, isExpanded) => {
    setExpandedRendimento(isExpanded ? panel : false);
  };

  async function addRodada() {
    try {
      setLoading(true);
      const visitaFiliadoTrap = {
        idVisitaFiliadoMod: visitaFiliado.visitaFiliadoMods[indexModalidade].idVisitaFiliadoMod,
        numeroRodada: visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoTrap[visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoTrap.length - 1].numeroRodada + 1,
        quantidadeAcertos: 0,
        acertoDisparo01: false,
        acertoDisparo02: false,
        acertoDisparo03: false,
        acertoDisparo04: false,
        acertoDisparo05: false,
        acertoDisparo06: false,
        acertoDisparo07: false,
        acertoDisparo08: false,
        acertoDisparo09: false,
        acertoDisparo10: false,
        acertoDisparo11: false,
        acertoDisparo12: false,
        acertoDisparo13: false,
        acertoDisparo14: false,
        acertoDisparo15: false,
        acertoDisparo16: false,
        acertoDisparo17: false,
        acertoDisparo18: false,
        acertoDisparo19: false,
        acertoDisparo20: false,
        acertoDisparo21: false,
        acertoDisparo22: false,
        acertoDisparo23: false,
        acertoDisparo24: false,
        acertoDisparo25: false
      };

      let result = await api.post('/visita-filiado-trap', visitaFiliadoTrap);
      if (result.data) {
        if (result.data.isSuccess) {
          setLoading(true);
          const dados = await api.get(`visita-filiados/${visitaFiliado.idVisitaFiliado}`);
          setLoading(false);
          if (dados.data.isSuccess) {
            if (dados.data.result && dados.data.result.length > 0) {
              setVisitaFiliado(dados.data.result[0])
              setLoading(false)
              setTypeSnack('success');
              setMessageSnack('Rodada de Trap Americano registrada com sucesso.');
              setShowMessageSnack(true);
            } else {
              setLoading(false);
              setTypeSnack('error');
              setMessageSnack(Values.MessageValues.erro_catch);
              setShowMessageSnack(true);
            }
          } else {
            setLoading(false);
            setTypeSnack('error');
            setMessageSnack(Values.MessageValues.erro_catch);
            setShowMessageSnack(true);
          }

        } else {
          setTypeSnack('error');
          setMessageSnack(result.data.message);
          setShowMessageSnack(true);
          setLoading(false);
        }
      } else {
        setTypeSnack('error');
        setMessageSnack(Values.MessageValues.erro_catch);
        setShowMessageSnack(true);
        setLoading(false);
      }

    } catch (e) {
      setTypeSnack('error');
      setMessageSnack(Values.MessageValues.erro_catch);
      setShowMessageSnack(true);
      setLoading(false);
    }
  }

  return (
    <Grid
      container
    >
      <Grid
        md={12}
        xs={12}
      >
        <ExpansionPanel
          expanded={expandedModalidade === 'panel1'}
          onChange={handleChange('panel1')}
          variant={'elevation'}
          style={{
            marginRight: 15,
            marginLeft: 15,
            marginBottom: 15
          }}
        >
          <ExpansionPanelSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <Typography className={classes.heading}>Trap americano</Typography>
            <Typography className={classes.secondaryHeading}>Acompanhamento de rendimento e disparos na modalidade de Trap Americano</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>


          <Grid
              container
            >
              <Grid
                item
                md={12}
                xs={12}
              >
                  <ModalidadeDetalhes
                    visitaFiliado={visitaFiliado}
                    setVisitaFiliado={setVisitaFiliado}
                    expandedDetalhes={expandedDetalhes}
                    setExpandedDetalhes={setExpandedDetalhes}
                    indexModalidade={indexModalidade}
                    setShowMessageSnack={setShowMessageSnack}
                    setMessageSnack={setMessageSnack}
                    setTypeSnack={setTypeSnack}
                    setLoading={setLoading}
                    armas={armas}
                    insumos={insumos}
                    pacotes={pacotes}

                  />
              </Grid>

                {visitaFiliado.visitaFiliadoMods &&
              visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoTrap &&
                visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoTrap.map((visitaFiliadoTrap, index) => {
                return <ExpansionPanelRodada
                  visitaFiliado={visitaFiliado}
                  setVisitaFiliado={setVisitaFiliado}
                  expandedRodadas={expandedRodadas}
                  setExpandedRodadas={setExpandedRodadas}
                  indexModalidade={indexModalidade}
                  indexVisitaFiliadoTrap={index}
                  setShowMessageSnack={setShowMessageSnack}
                  setMessageSnack={setMessageSnack}
                  setTypeSnack={setTypeSnack}
                  setLoading={setLoading}
                />
              })
              }
              <Grid
                item
                md={12}
                xs={12}
                style={{
                  marginTop: 10
                }}
              >
                <ExpansionPanel
                  expanded={expandedRendimento === ('panel2')}
                  onChange={handleChangeExpandedRendimento('panel2')}
                  variant={'outlined'}
                >
                  <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                  >
                    <Typography className={classes.heading}>{'Rendimento Geral'}</Typography>
                    <Typography className={classes.secondaryHeading}>{'Gráficos para contabilização geral do rendimento do filiado na modalidade de Trap Americano'}</Typography>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                    <Grid
                      item
                      md={6}
                      xs={12}
                    >
                      <Card
                        variant={'outlined'}
                        className={classes.cardChart}
                      >
                        <CardHeader
                          title={'Rendimento geral'}
                        />
                        <CardContent>
                          <div
                            className={classes.chartContainer}
                          >
                            <Doughnut
                              data={dataDoughnut}
                              options={options}
                            />
                          </div>

                          <Grid
                            container
                            style={{
                              marginTop: 20
                            }}
                          >
                            <Grid
                              item
                              lg={9}
                              sm={9}
                              xl={9}
                              xs={9}
                            >
                              <Typography
                                style={{ color: theme.palette.text.primary }}
                                variant="h5"
                              >
                                {'Percentual Acertos:'}
                              </Typography>
                            </Grid>
                            <Grid
                              item
                              lg={3}
                              sm={3}
                              xl={3}
                              xs={3}
                              key={percentualAcertos}

                            >
                              <Typography
                                style={{
                                  color: theme.palette.text.primary,
                                  textAlign: 'right'
                                }}
                                variant="h5"
                              >
                                {percentualAcertos.toFixed(2)}%
                              </Typography>
                            </Grid>
                            <Grid
                              item
                              lg={9}
                              sm={9}
                              xl={9}
                              xs={9}
                              style={{
                                marginTop: 10
                              }}
                            >
                              <Typography
                                style={{ color: theme.palette.text.primary }}
                                variant="h5"
                              >
                                {'Percentual Erros:'}
                              </Typography>
                            </Grid>
                            <Grid
                              item
                              lg={3}
                              sm={3}
                              xl={3}
                              xs={3}
                              key={percentualErros}
                              style={{
                                marginTop: 10
                              }}

                            >
                              <Typography
                                style={{
                                  color: theme.palette.text.primary,
                                  textAlign: 'right'
                                }}
                                variant="h5"
                              >
                                {percentualErros.toFixed(2)}%
                              </Typography>
                            </Grid>

                          </Grid>
                        </CardContent>
                      </Card>
                    </Grid>
                    <Grid
                      item
                      md={6}
                      xs={12}
                    >
                      <Card
                        variant={'outlined'}
                        className={clsx(classes.cardChart, classes.cardBarChart)}
                      >
                        <CardHeader
                          title="Rendimento por rodada"
                        />
                        <CardContent>
                          <div className={clsx(classes.chartContainer, classes.cardBarChart)}>
                            <Bar
                              data={dataBar}
                              options={options}
                            />
                          </div>
                          <Grid
                            container
                            style={{
                              marginTop: 20
                            }}
                          >
                            <Grid
                              item
                              lg={12}
                              sm={12}
                              xl={12}
                              xs={12}
                            >
                              <Typography
                                variant="h6"
                              >
                                Dados obtidos de acordo com a totalização de todas as rodadas praticadas
                              </Typography>
                            </Grid>
                          </Grid>
                        </CardContent>
                      </Card>
                    </Grid>
                  </ExpansionPanelDetails>

                </ExpansionPanel>
              </Grid>

            </Grid>

          </ExpansionPanelDetails>

        </ExpansionPanel>
      </Grid>

    </Grid>
  );
}

ModalidadeTrapAmericano.propTypes = {
  className: PropTypes.string,
  visitaFiliado: PropTypes.object.isRequired,
  setVisitaFiliado: PropTypes.object.isRequired
};

export default ModalidadeTrapAmericano;


